import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react'
import { filterOffersByAddedAt, getOfferDateBounds } from './offerAgeFilter'

const DEFAULT_FILTER = { range: 'all', setRange: () => {} }
const OfferAgeFilterContext = createContext(DEFAULT_FILTER)

export const OfferAgeFilterProvider = ({ children, scopeKey }) => {
  const [range, setRangeState] = useState('all')
  const setRange = useCallback(nextRange => {
    setRangeState(getOfferDateBounds(nextRange) ? nextRange : 'all')
  }, [])

  useEffect(() => {
    setRange('all')
  }, [scopeKey, setRange])

  const value = useMemo(() => ({ range, setRange }), [range, setRange])
  return (
    <OfferAgeFilterContext.Provider value={value}>
      {children}
    </OfferAgeFilterContext.Provider>
  )
}

export const useOfferAgeFilter = () => useContext(OfferAgeFilterContext)

export const useAddedAtFilteredOffers = offers => {
  const { range } = useOfferAgeFilter()
  return useMemo(() => filterOffersByAddedAt(offers, range), [offers, range])
}
